export default __webpack_public_path__ + "static/media/litho-demo-finance.921866ee.jpg";